var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_1625)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_194_1625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_194_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0427 10.7324C22.4424 5.02063 17.1462 0.895634 11.2148 1.51904C5.28351 2.14245 0.960684 7.27844 1.56101 12.9902L3.73529 33.677L25.217 31.4192L23.0427 10.7324Z",
    fill: "#ACFF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1256 13.1898C13.2623 13.6999 13.0634 14.2004 12.6786 14.3035C12.2938 14.4066 11.8713 14.0726 11.7347 13.5625C11.598 13.0525 11.7968 12.552 12.1817 12.4489C12.5665 12.3458 12.9889 12.6798 13.1256 13.1898ZM16.3007 11.5937C15.5565 11.7931 15.342 12.1885 15.3842 12.3461C15.5954 13.1343 15.7671 12.579 16.5113 12.3796C17.2554 12.1802 17.6812 12.573 17.4706 11.7871C17.4284 11.6294 17.0448 11.3943 16.3007 11.5937Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0528 17.6233C13.6234 18.2743 12.6284 16.5084 12.7484 16.3073C12.8685 16.1062 13.9689 16.3182 15.587 15.8846C17.2074 15.4504 18.052 14.7173 18.2565 14.8314C18.4611 14.9456 18.4823 16.9723 16.0528 17.6233Z",
    fill: "#080808"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_1625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.b2f59487659a211f8683c0b71dc31b24.svg";
export { ForwardRef as ReactComponent };